import React from 'react';
import bdedu1 from '../../images/project/bdedu1.PNG'
import bdedu2 from '../../images/project/bdedu2.PNG'
import bdedu3 from '../../images/project/bdedu3.PNG'


const Project3 = () => {
    return (
        <div>
            <div>
                <h2 className="mt-4 mb-2"> Project Details</h2>
                <p class="card-text">● Authentication system added (user & admin) <br />
                    ● Users can take any kind of health service <br />
                    ● React, React Router, Firebase, Bootstrap, MongoDB, Express were used for this site</p>
            </div>
            <div>
                <div>
                    <h2 className="mt-4 mb-3">Project Screenshots</h2>
                </div>
                <div className="row" >
                    <div class="card-group">
                        <div class="card">
                            <img src={bdedu1} class="img-thumbnail" alt="..." />
                            <div class="card-body">
                                <h5 class="card-title">HOME PAGE SECTION</h5>

                            </div>

                        </div>
                        <div class="card">
                            <img src={bdedu2} class="img-thumbnail" alt="..." />
                            <div class="card-body">
                                <h5 class="card-title">COURSE PAGE SECTION</h5>

                            </div>

                        </div>
                        <div class="card">
                            <img src={bdedu3} class="img-thumbnail" alt="..." />
                            <div class="card-body">
                                <h5 class="card-title">CONTACT PAGE SECTION</h5>

                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <div >

                <button type="button" class="btn m-2 btn-success"><a className="text-white" target="_blank" style={{ textDecoration: 'none' }} href="https://serene-joliot-180ceb.netlify.app/" >Live Site</a>
                </button>
                <button type="button" class="btn m-2 btn-danger"><a className="text-white" target="_blank" style={{ textDecoration: 'none' }} href="https://github.com/ahadakash/healthcare-site" >Github Code</a>
                </button>


            </div>
        </div>
    );
};

export default Project3;